function getDomHTMLfromSpecs(viewSpecs) {
  return viewSpecs.map(spec => {
    let o = document.querySelector(`#view-${spec.uid}`).cloneNode(true)
    o.style.position = "relative";
    o.style.left = null;
    o.style.top = null;
    o.style.transform = null;
    return getDomHTML(o);
  })
}
function getDomHTML(dom) {
  return dom.outerHTML;
}
function getQueryConditions(viewSpecs) {
  let conditions = [];
  let n = viewSpecs.length;
  conditions = viewSpecs.map(spec => {
    return {
      id: spec.uid,
      width: spec.artboard.device_width,
      aspectRatio: spec.artboard.screen_type.split("-")[1]
    }
  });
  conditions = conditions.sort((a, b) => b.width - a.width);
  return conditions.map((cond, i, arr) => {
    let query = {
      id: cond.id
    };
    if (i == 0) { // largest
      query["min-width"] = cond.width + "px";
    } else { // non-largest
      query["max-width"] = (arr[i - 1].width - 1) + "px";
      query["min-width"] = cond.width + "px";
    }
    if (cond.aspectRatio === "Square") {
      query["aspect-ratio"] = "1/1";
    } else if (cond.aspectRatio === "Landscape") {
      query["orientation"] = "landscape";
    } else if (cond.aspectRatio === "Portrait") {
      query["orientation"] = "portrait";
    } else if (cond.aspectRatio === "Radial") {
      // not fully supported on current browsers yet; may a signal to a rounded devices;
      query["shape"] = "round";
    }
    query.queryString = makeQueryString(query);
    return query;
  });
}
function makeQueryString(query) {
  let base = "@media screen and ";
  return base + Object.keys(query).filter(q => validQueryKey(q)).map(q => `(${q}: ${query[q]})`).join(" and ");
}

function validQueryKey(q) {
  return ["min-width", "max-width", "aspect-ratio", "orientation", "shape"].includes(q);
}

function makeConditioningCSS(queryConditions, viewSpecs, pid) {
  return queryConditions.map((query, i, arr) => {
    let base = query.queryString;
    base += " { "
    base += viewSpecs.map(spec => {
      console.log(spec.uid, query.id)
      if (spec.uid === query.id) {
        console.log(spec.uid, query.id)
        return `#${pid} > #view-${spec.uid} { display: initial; }
        `;
      } else return "";
    }).join("\n");
    base += ` }
    `;
    return base;
  });
}
function generateHTMLoutput(viewSpecs) {
  // let artboardSpecs = viewSpecs.map(spec => spec.artboard);
  let projectID = getProjectID();
  let queryConditions = getQueryConditions(viewSpecs);
  let innerHTMLs = getDomHTMLfromSpecs(viewSpecs);
  let css = makeConditioningCSS(queryConditions, viewSpecs, projectID).join("\n");
  let html = `
<html>
  <head>
    <style>
      body {
        margin: 0;
        padding: 0;
        height: 100%;
      }
      
      .vg-on_mark-tooltip {
        visibility: hidden;
        padding: 8px;
        position: fixed;
        z-index: 1000;
        width: auto;
        font-family: sans-serif;
        font-size: 11px;
        border-radius: 3px;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
        background-color: rgba(255, 255, 255, 0.95);
        border: 1px solid #d9d9d9;
        color: black;
      }
      
      .vg-on_mark-tooltip table {
        margin: 0 auto;
      }
      
      .vg-on_mark-tooltip td.key{
        color: #808080;
        text-align: left;
        padding-right: 5px;
      }
      
      .vg-on_mark-tooltip td.value{
        color: black;
        text-align: left;
        padding-left: 4px;
        max-height: 7em;
      }
      
      .view-wrapper {
        display: block;
        font-family: "Arial";
        background: #ffffff; 
      }
      #${projectID} > div { display: none; }
      ${css}
    </style>
  </head>
  <body>
    <section id="${projectID}">
    ${innerHTMLs.join("\n")}
    </section>
  </body>
</html>
  `;
  return { html, css };
}

const availLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.split('');
const nLetters = availLetters.length;
const rsLength = 6;
function getProjectID() {
  let r = new Array(rsLength).fill(0).map(d => availLetters[Math.floor(Math.random() * nLetters)]).join('');
  return "dupo_" + r;
}

export { generateHTMLoutput };